import { showNotification } from "@/entities/notification"
import { registerNotification } from "@/shared/api/websocket"
import { characterKeys } from "../api/keys"

registerNotification("character_message", {
	handle: ({ notification_id, data }, ctx) => {
		showNotification({
			type: "character-message",
			placement: "home",
			notificationId: notification_id,
			character: data.character,
			text: data.text,
			origin: "server",
			name: "character_message",
		})
		ctx.queryClient.invalidateQueries({
			queryKey: characterKeys.lastMessage(data.character, ctx.userId),
		})
	},
	route: ({ data }) => ({
		to: "/board/character/$character",
		params: { character: data.character },
	}),
	routePopup: null,
})
